import { render, staticRenderFns } from "./NovaVenda.vue?vue&type=template&id=3f0181c8&scoped=true"
import script from "./NovaVenda.vue?vue&type=script&lang=js"
export * from "./NovaVenda.vue?vue&type=script&lang=js"
import style0 from "./NovaVenda.vue?vue&type=style&index=0&id=3f0181c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0181c8",
  null
  
)

export default component.exports